import { render } from "./doctorInfo.vue?vue&type=template&id=3cfb4df2"
import script from "./doctorInfo.vue?vue&type=script&lang=js"
export * from "./doctorInfo.vue?vue&type=script&lang=js"

import "./doctorInfo.vue?vue&type=style&index=0&id=3cfb4df2&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__